import React, { useEffect, useState } from "react";
import { apiPath } from "../../utilities/Constants";
import useFetch from "../../hooks/useFetch";
import GlobalForm from "../../components/globalForm/GlobalForm";
import { updateData } from "../../hooks/update";
import Loader from "../../components/shared/Loader/Loader";
import LoaderFilling from "../../components/shared/Loader/LoaderFilling";

function FooterPage() {
  const { homeApi } = apiPath;
  const [apiData, apiDataLoading] = useFetch(homeApi);
  const [filteredData, setFilteredData] = useState({});

  // filter by slug
  useEffect(() => {
    setFilteredData(apiData.filter((item) => item)[0]);
  }, [apiData]);

  if (apiDataLoading) {
    return <LoaderFilling />;
  }

  const { companyName, link, _id } = filteredData ?? {};

  // // map socials
  // const socialLinksData = [];
  // socialMedia?.map((item, index) => {
  //   socialLinksData.push({
  //     label: `Social Links ${index + 1}`,
  //     type: "text",
  //     name: "socialMedia",
  //     defaultValue: item,
  //   });
  // });

  // Form data
  const data = [
    {
      elementType: "heading",
      label: `Update Footer`,
      name: "heading",
      type: "heading",
      firstElement: true,
    },
    {
      elementType: "input",
      label: `Company Name`,
      name: "companyName",
      type: "text",
      fullCol: true,
      defaultValue: companyName,
      required: false,
    },
    {
      elementType: "input",
      label: `Website Link`,
      name: "link",
      type: "text",
      fullCol: true,
      defaultValue: link,
      required: false,
    },
  ];

  const update = (data) => {
    delete data.heading;
    updateData(homeApi, data, _id);
  };

  return (
    <div className="px-4 lg:px-8">
      {_id && <GlobalForm data={data} update={update} />}
    </div>
  );
}

export default FooterPage;
